import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3000/api";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Интерцептор для добавления Telegram initData в каждый запрос
api.interceptors.request.use((config) => {
  const initData = window.Telegram?.WebApp?.initData;
  if (initData) {
    config.headers["x-telegram-init-data"] = initData;
  } else {
    // Для локальной разработки без Telegram Web App
    console.log(
      "⚠️ Telegram InitData отсутствует, работаем в режиме разработки"
    );
  }
  return config;
});

// Auth API
export const authAPI = {
  verify: (initData) => api.post("/auth/verify", { initData }),
};

// User API
export const userAPI = {
  getProfile: () => api.get("/user/profile"),
};

// Stamps API
export const stampsAPI = {
  getAll: (type) => api.get("/stamps", { params: { type } }),
  getImage: (id) => api.get(`/stamps/${id}/image`, { responseType: "blob" }),
  delete: (id) => api.delete(`/stamps/${id}`),
  upload: (file, type) => {
    const formData = new FormData();
    formData.append("stamp", file);
    formData.append("type", type);
    return api.post("/stamps/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};

// Documents API
export const documentsAPI = {
  upload: (file) => {
    const formData = new FormData();
    formData.append("document", file);
    return api.post("/documents/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  sign: (documentId, stamps, isPending = false) => {
    console.log('🟢 API.SIGN ВЫЗВАН С ПАРАМЕТРАМИ:', { documentId, stamps, isPending });
    console.log('🟢 stamps детально:', JSON.stringify(stamps, null, 2));
    return api.post("/documents/sign", { documentId, stamps, isPending });
  },
  getHistory: (limit, offset) =>
    api.get("/documents/history", { params: { limit, offset } }),
  download: (id) =>
    api.get(`/documents/${id}/download`, { responseType: "blob" }),
  delete: (id) => api.delete(`/documents/${id}`),
};

// Pending Documents API
export const pendingDocumentsAPI = {
  getAll: () => api.get("/pending-documents"),
  getById: (id) => api.get(`/pending-documents/${id}`),
  download: (id) =>
    api.get(`/pending-documents/${id}/download`, { responseType: "blob" }),
  delete: (id) => api.delete(`/pending-documents/${id}`),
};

// Subscription API
export const subscriptionAPI = {
  getStatus: () => api.get("/subscription/status"),
  getHistory: () => api.get("/subscription/history"),
  getSavedCard: () => api.get("/subscription/saved-card"),
  unlinkCard: () => api.delete("/subscription/saved-card"),
};

export default api;
